import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["select", "categories"];

  connect() {
    this.actualRole = this.selectTarget.value;
  }

  resetInputs(e) {
    const newRole = e.target.value;

    if (this.actualRole === "author" && (newRole === "admin" || newRole === "superadmin")) {
      const tagsContainers = this.element.querySelectorAll(".tagify");
      [...tagsContainers].forEach((tag) => {
        const closeBtns = tag.querySelectorAll(".tagify__tag__removeBtn");
        if (closeBtns.length > 0) closeBtns.forEach((btn) => btn.click());
      });
    }
  }
}
